<span>{{ label ? (label | translate) + ':' : '' }} {{ value }}</span>
